
export const BACKEND_URI = "https://meteosarria-back.onrender.com";
//export const BACKEND_URI = "http://localhost:5000";


export const RAIN_2025_CANBRUIXA = 608.6; // Total precipitation for Sarrià in 2025 (mm)
export const RAIN_2025_BURGOS = 573.7; // Total precipitation for Burgos in 2025 (mm)

export const WIDTH_PC = '580px';
export const WIDTH_MOBILE = '500px';
export const WIDTH_TABLET = '550px';
export const HEIGHT_PC = "300px";
export const HEIGHT_MOBILE = "250px";
export const HEIGHT_TABLET = "300px";

export const MAX_VALUE_X = "23%";
export const MAX_VALUE_RAD_X = "80%";
export const MAX_VALUE_HIS_X = "27%";
export const MAX_VALUE_Y = "10%";
export const MAX_VALUE_RAD_Y = "13%";
export const MAX_VALUE_HIS_Y = "9%";

export const MAX_TIME_X = "38%";
export const MAX_TIME_RAD_X = "96%";
export const MAX_TIME_HIS_X = "19%";
export const MAX_TIME_Y = "10%";
export const MAX_TIME_RAD_Y = "13%";
export const MAX_TIME_HIS_Y = "16%";

export const MIN_VALUE_X = "73%";
export const MIN_VALUE_Y = "10%";
export const MIN_VALUE_HIS_X = "85%";
export const MIN_VALUE_HIS_Y = "9%";
export const MIN_TIME_X = "88%";
export const MIN_TIME_Y = "10%";
export const MIN_TIME_HIS_X = "79%";
export const MIN_TIME_HIS_Y = "16%";

export const SHOW_COLOUR_BAR = false;